import * as themeAddresses from '@shopify/theme-addresses';
import * as themeCurrency from '@shopify/theme-currency';
import * as themeImages from '@shopify/theme-images';
import AOS from 'aos';
import * as Sqrl from 'squirrelly';
import Flickity from 'flickity/js/index';
import FlickityFade from 'flickity-fade/flickity-fade';
import Rellax from 'rellax';
import * as BodyScrollLock from 'body-scroll-lock';
import * as ellipsis from 'ellipsed';

// Flickity iOS 15 hack
let originalWidth = window.innerWidth;
const resizePrototype = Flickity.prototype.resize;
Flickity.prototype.resize = function () {
  if (window.innerWidth === originalWidth && window.innerWidth <= 480) {
    // No width resize on mobile, unless landscape and over 480
    return;
  }
  originalWidth = window.innerWidth;
  // Call Flickity.prototype.resize function, triggering resize
  resizePrototype.apply(this, arguments);
};

export {themeAddresses, themeCurrency, themeImages, AOS, Sqrl, Flickity, FlickityFade, Rellax, BodyScrollLock, ellipsis};
